const config = {
  ARRAY_SIZE_DEFAULT: 120,
  ARRAY_SIZE_MIN: 20,
  ARRAY_SIZE_MAX: 120,
  ARRAY_SIZE_STEP: 10,
  ANIMATION_SPEED_DEFAULT: 1, //ms
  ANIMATION_SPEED_MIN: 1, //ms
  ANIMATION_SPEED_MAX: 1000, //ms
  ANIMATION_SPEED_STEP: 1,
  BAR_WIDTH_MIN: 2, //px
  ANIMATION_DEFAULT_BACKGROUND_COLOR_BARS: "#2ca08b",
  ANIMATION_COMPARE_COLOR: "orange",
  ANIMATION_SWAP_COLOR: "red",
  ANIMATION_SORTED_COLOR: "purple",
  ANIMATION_PIVID_COLOR: "black",
};

export default config;
